import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { AutoSizer, List, ListRowProps } from 'react-virtualized';
const DefaultItemHeight = 32;
const DefaultSeparatorHeight = 16;

export default function ReactSelectVirtualMenuList(props: any) {
    const { children, maxHeight, viewSettings } = props;
    const childrenOptions = React.Children.toArray(children);
    const isScrollable = maxHeight < childrenOptions.length * DefaultItemHeight;
    const renderElementId = '__render_area' + props.selectProps.instanceId;
    const rows = children;

    const heightCache = useMemo(() => new Map<string, number>(), []);
    const addHeightToCache = (key: string, height: number): number => {
        heightCache.set(key, height);
        return height;
    };

    const rowRenderer = ({ key, index, style }: ListRowProps) => (
        <Box key={key} style={style} className="react-virtualized-list__item">
            {rows[index]}
        </Box>
    );

    const getRowHeight = (row: any) => {
        const textToRender = row?.props?.data?.label ?? '';
        const separator = row?.props?.data?.value === 'sep';
        if (separator) {
            return DefaultSeparatorHeight;
        }
        if (textToRender.length == 0) {
            return DefaultItemHeight;
        }
        if (heightCache.has(textToRender)) {
            return heightCache.get(textToRender) ?? DefaultItemHeight;
        }
        const element = document.getElementById(renderElementId);
        if (!element) {
            return DefaultItemHeight;
        }
        if (row?.props?.data?.icon) {
            // TODO: add space for icon
        }
        element.innerText = textToRender;
        return addHeightToCache(textToRender, element.clientHeight);
    };

    const totalWrapperHeight = useMemo(() => {
        let s = maxHeight;
        if (rows?.length < 10) {
            s = rows.reduce((t: number, row: any) => t + getRowHeight(row), 0);
        }
        return s > maxHeight ? maxHeight : s;
    }, [Array.isArray(rows) ? rows.length : 0, maxHeight]);

    if (!Array.isArray(rows)) {
        return <>{children}</>;
    }

    return (
        <div style={{ height: totalWrapperHeight }}>
            {/*// @ts-ignore*/}
            <AutoSizer>
                {({ width, height }) => (
                    // @ts-ignore
                    <List
                        width={width}
                        height={height}
                        rowHeight={({ index }) => getRowHeight(rows[index])}
                        rowCount={rows.length}
                        rowRenderer={rowRenderer}
                    />
                )}
            </AutoSizer>
            <div
                className="react-virtualized-list"
                style={{
                    overflowY: isScrollable ? 'scroll' : 'hidden',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    visibility: 'hidden',
                    pointerEvents: 'none',
                }}
            >
                <Box
                    id={renderElementId}
                    className="react-virtualized-list__item"
                    style={viewSettings.styles.option({}, {})}
                />
            </div>
        </div>
    );
}
